module.exports = __webpack_public_path__ + "img/motor.af4db551.svg";